export const BLOCKY_NAV = "BLOCKY_NAV";
export const NAVIGATE_TO_PORTFOLIOS = "NAVIGATE_TO_PORTFOLIOS";
export const STATE_HISTORY = "STATE_HISTORY";
export const GET_BLOGS = "GET_BLOGS";
export const GET_CONTENT = "GET_CONTENT";
export const SAVE_BIOS = "SAVE_BIOS";
export const GET_CASE_STUDIES = "GET_CASE_STUDIES";
